import { Component } from "preact";
import PropTypes from "prop-types";
import { applicationThunk } from "../../store/store";
import { E_Route } from "../../models/constants/Enum_Routes";
import { RouteUtils } from "../../utils/RouteUtils";
import { IdleManager, Jiffy } from "@green24/npm-javascript-utils";
import { APP_CONSTANTS } from "../../models/constants/AppConstants";
import Match from "preact-router/match";
import withConfiguration from "../shared/hoc/withConfiguration";
import { DEFAULT_CONFIGURATION } from "../../models/Models_Configuration";

class RouteListener extends Component {
	constructor(props) {
		super(props);

		this._listener = () => null;
		this._location = window.location;
		this._updateIdle = new IdleManager(
			() => this._triggerUpdate(),
			Jiffy.formatToMs((props.configuration ?? DEFAULT_CONFIGURATION).updateWaitTime)
		);

		this._lastInteraction = Date.now();
	}

	componentDidMount() {
		const {configuration} = this.props;

		this._setReturnRoutes();
		this._setIdleTimeouts();

		//Display update handler
		window.addEventListener(APP_CONSTANTS.IDLE_RESET, () => {
			//Update last interaction time
			this._lastInteraction = Date.now();

			if(window[APP_CONSTANTS.DISPLAY_UPDATE]) {
				//User has interacted, update will have to wait...
				this._setIdleForUpdate();
			}
		});

		window.addEventListener(APP_CONSTANTS.DISPLAY_UPDATE, () => {
			//If the last user interaction was more than updateWaitTime ago, update immediately
			if(this._lastInteraction + Jiffy.formatToMs((configuration ?? DEFAULT_CONFIGURATION).updateWaitTime) <= Date.now()) {
				this._updateIdle.forceTrigger();
			}
			else {
				this._setIdleForUpdate();

				//Listen for idle redirect from <IdleTimeout/>
				window.addEventListener("idle-redirect", () => {
					//If the idle redirect has redirected back to the index (means no interaction for a while, assume that the user has left), update immediately
					this._updateIdle.forceTrigger();
				});
			}
		});
	}

	_setReturnRoutes() {
		if(this._matchRoute(E_Route.BASE)) {
			applicationThunk.setReturnData(null);
		}
		else {
			applicationThunk.setReturnData(E_Route.BASE);
		}
	}

	_setIdleTimeouts() {
		applicationThunk.setIdleTimeout();
	}

	_setIdleForUpdate() {
		this._updateIdle.trigger();
	}

	_triggerUpdate() {
		if(this._matchRoute(E_Route.BASE)) {
			window.location.reload();
		}
	}

	_matchRoute(target, location = this._location) {
		return RouteUtils.matchRoute(target, location);
	}

	_getParams(target, location = this._location) {
		return RouteUtils.getParams(target, location);
	}

	componentWillUnmount() {
		this._listener();
	}

	render() {
		return <Match>{() => {
			if(this._oldLocation != this._location) {
				this._location = window.location;

				this._setReturnRoutes();
				this._setIdleTimeouts();

				this._oldLocation = this._location;
			}
		}}</Match>;
	}

	static get propTypes() {
		return {
			//withConfiguration
			configuration: PropTypes.object,
		}
	}
}

export default withConfiguration(RouteListener);
